import React from 'react'
import MergeOfInstApplicationDetails from './MergeOfInstApplicationDetails'

export default function MergerOfInstitutions() {
    return (
        <>
            <MergeOfInstApplicationDetails />
        </>
    )
}
